import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import css from './AlternativeHero.module.css';
import Button from '../Button/Button';

const AlternativeHero = () => {
  const history = useHistory();
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.play().catch(error => {
        // Autoplay was prevented
        // We can't really do much about it here, but it's good to know
        console.warn('Autoplay prevented:', error);
      });
    }
  }, []);

  return (
    <div className={css.alternativeHero}>
      <video
        ref={videoRef}
        className={css.backgroundVideo}
        autoPlay={true}
        loop={true}
        muted={true}
        playsInline={true}
        defaultMuted={true}
      >
        <source src="/static/video/hero.mp4" type="video/mp4" />
      </video>
      <div className={css.overlay} />
      <div className={css.content}>
        <p className={css.mainTitle}>
          BUY & SELL MARTIAL ARTS GEAR. <br />
          FIND LOCAL GYMS.
        </p>

        <p className={css.description}>
          Discover affordable brand new and second-hand gear, explore nearby
          gyms, and join a community built around discipline, respect, and
          personal growth.
        </p>

        <div className={css.buttonGroup}>
          <Button
            className={css.primaryButton}
            variant="primary"
            text="Browse gear"
            onClick={() => history.push('/product?pub_listingType=product-selling')}
          />
          <Button
            className={css.secondaryButton}
            variant="secondary"
            text="Find gyms"
            onClick={() => history.push('/gym?pub_listingType=gym')}
          />
        </div>
      </div>
    </div>
  );
};

export default AlternativeHero;

